import React, { Fragment } from 'react';
import { Parallax } from 'react-scroll-parallax';
import { ReactSVG } from 'react-svg';
import Media from 'react-media';
import { MOBILE_WIDTH } from '../../constants';
import Showcase from '../common/Showcase';
import checkAndX from '../../assets/shapes/overview.svg';
import triPat from '../../assets/shapes/rackPat.svg';
import marquise from '../../assets/shapes/marquise.svg';
import styles from './Overview.module.scss';
import imageSource from '../../assets/screenshots/4-home.png';

const pattern = {
	title: 'High Level View',
	content: 'Get a big picture look at your growth for multiple goals and the patterns that make those goals up.',
	featureTitle: 'Features',
	features: [
		'Quickly see the patterns that will get you to your goal.',
		'A view of your current execution for the week.',
		'Easily record execution for multiple patterns.',
	],
	imageSource,
};

const Overview = (props) => {
	const { centerCluster, centerStyle, center, centerSM, border, primaryGreen, primaryRed, primaryBlue, lead, trail, rackPat } = styles;
	return (
		<Fragment>
			<Showcase item={pattern} bubbleStyle={border}>
				<Parallax translateX={[100, -400]} translateY={[400, -300]} className={lead}>
					<ReactSVG src={marquise} style={{ fill: primaryRed }} />
				</Parallax>

				<Parallax translateX={[100, -400]} translateY={[100, -300]} className={trail}>
					<ReactSVG src={marquise} style={{ fill: primaryGreen }} />
				</Parallax>

				<div className={centerCluster}>
					<Parallax translateY={[100, -100]} className={centerStyle}>
						<Media query={{ maxWidth: MOBILE_WIDTH }}>{(matches) => <ReactSVG src={checkAndX} className={`${matches ? centerSM : center}`} />}</Media>
					</Parallax>
				</div>

				<Parallax translateX={[150, 20]} translateY={[-200, 300]} className={rackPat}>
					<ReactSVG src={triPat} />
				</Parallax>
			</Showcase>
		</Fragment>
	);
};

export default Overview;
